var ko = require('knockout'),
  filter = require('lodash/filter'),
  Cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  HOURS_TYPE = require('_js/constants/hours'),
  CalculatorTracking = require('../calculator-tracking'),
  CalculatorUtil = require('./calculator-util'),
  decodeHtml = require('_utils/text');
require('knockout-postbox');

function CalculatorBar(params) {
  var self = this;
  this.title = params.data.Name;
  this.showMissingHoursError = params.data.ShowMissingHoursError;
  this.AuthorizationType = params.data.AuthorizationType;
  this.parent = params.parent;
  this.API = params.parent.API;
  this.texts = params.parent.params.texts;
  this.links = params.parent.links;
  this.order = params.order();
  this.isRNFriProduct = params.isRNFriProduct;
  this.mobileSize = ko.observable('large').subscribeTo('resize', true);
  this.mobileView = ko.computed(function() {
    if (self.mobileSize() === 'medium') {
      return true;
    } else {
      return false;
    }
  });
  this.CategoryKey = params.data.CategoryKey;
  this.isExpanded = ko.observable(false);
  this.hoursToAdd = ko.observable(0);
  this.firstEmptyIndex = -1;
  this.firstSubEmptyIndex = -1;
  this.firstOtherEmptyIndex = -1;
  this.startYear = ko.observable(0).subscribeTo('currentStartYear', true);
  this.endYear = ko.observable(0).subscribeTo('currentEndYear', true);
  this.changeInPeriod = ko.observable(0).subscribeTo('changeInPeriod', true);

  this.newYear = ko.observable(0).subscribeTo('currentYearChange', true);
  this.periodClicked = false;
  // Will be triggered everytime the user has clicked the arrow buttons (change period).
  this.newYear.subscribe(function() {
    self.periodClicked = true;
  });

  this.BLOCKS_OTHER_AMOUNT = 0;

  this.updateCounterLock = ko.observable(false);
  this.changeInPeriodLock = ko.observable(false);
  this.updateCounterLock.subscribe(function() {
    if (self.updateCounterLock() && self.changeInPeriodLock()) {
      self.updateCounterLock(false);
      self.changeInPeriodLock(false);
      self.periodClicked = false;
      updateData();
      updateShopping();
      self.updateAllHours();
    }
  });
  this.changeInPeriodLock.subscribe(function() {
    if (self.updateCounterLock() && self.changeInPeriodLock()) {
      self.updateCounterLock(false);
      self.changeInPeriodLock(false);
      self.periodClicked = false;
      updateData();
      updateShopping();
      self.updateAllHours();
    }
  });

  this.currentYear = new Date().getFullYear();
  this.isSpecialBar = false;

  // Just reassigning values. These params values are already observables.
  this.totalHoursDone = ko.observable(params.data.TotalHoursDone());

  this.doneHoursFromCurrentCategory = ko.observable(
    params.data.DoneStructuredHoursFromCurrentCategory()
  );
  this.doneUnstructuredHoursFromCurrentCategory = ko.observable(
    params.data.DoneUnstructuredHoursFromCurrentCategory()
  );
  this.plannedHoursFromCurrentCategory = ko.observable(
    params.data.PlannedHoursFromCurrentCategory()
  );
  this.timeMissingClass = ko.computed(function() {
    var isExpanded = self.isExpanded(),
      timeClass = '';

    if (isExpanded) {
      timeClass = 'notification-black';
    } else {
      timeClass = 'notification-white';
    }

    return timeClass;
  });

  this.blocks = ko.observableArray([]);
  // Triggered whenever we fetch categories from API and set new values in the observable.
  params.data.UpdateCounter.subscribe(function() {
    if (self.periodClicked) {
      self.updateCounterLock(true);
    } else {
      updateData();
      updateShopping();
      self.updateAllHours();
    }
  });

  function updateData() {
    self.localShoppingHours(0);
    self.doneHoursFromCurrentCategory(
      params.data.DoneStructuredHoursFromCurrentCategory()
    );
    self.doneUnstructuredHoursFromCurrentCategory(
      params.data.DoneUnstructuredHoursFromCurrentCategory()
    );
    self.plannedHoursFromCurrentCategory(
      params.data.PlannedHoursFromCurrentCategory()
    );

    self.totalHoursDone(params.data.TotalHoursDone());
  }

  function updateShopping() {
    var courses = Cart.getCart().courses;
    if (courses.length > 0) {
      self.setHoursShopping(courses);
    }
  }

  this.parent.activeBar.subscribe(function(newIndex) {
    if (self.order === newIndex) {
      self.isExpanded(true);
    } else {
      self.isExpanded(false);
    }
  });

  // We have to use changeInPeriod as it is updated after startYear.
  this.changeInPeriod.subscribe(function() {
    if (self.periodClicked) {
      self.changeInPeriodLock(true);
    } else {
      updateData();
      updateShopping();
      self.updateAllHours();
    }
  }, this);

  this.localShoppingHours = params.data.Shopping;

  this.updateAllHours();

  ko.postbox.subscribe(
    'shoppingCartUpdated',
    function(newCart) {
      var courses = newCart.courses;
      self.setHoursShopping(courses);
      self.updateAllHours();
    },
    this,
    true
  );

  ko.postbox.subscribe('externalCourseAdded', function() {}, this, true);

  this.animateHours = function(elem, index) {
    if (elem.nodeType === 1) {
      window.setTimeout(function() {
        $(elem).addClass('animate-in');
      }, 50 * index);
    }
  };
}

CalculatorBar.prototype.updateAllHours = function() {
  // 1: Get the calculated hours we should use for the visual representation.
  var calculatedHours = this.calculateHours();
  // 2: Update the main bar.
  this.blocks(this.addHoursToBlock(calculatedHours.main));
};

CalculatorBar.prototype.calculateHours = function() {
  return CalculatorUtil.calculateHours({
    CategoryKey: this.CategoryKey,

    doneHoursFromCurrentCategory: this.doneHoursFromCurrentCategory(),
    doneUnstructuredHoursFromCurrentCategory: this.doneUnstructuredHoursFromCurrentCategory(),
    plannedHoursFromCurrentCategory: this.plannedHoursFromCurrentCategory(),
    localShoppingHours: this.localShoppingHours()
  });
};

CalculatorBar.prototype.addHoursToBlock = function(hourSettings) {
  var tmpBlocks = [];
  tmpBlocks = tmpBlocks.concat({
    classType: 'timeunit-' + HOURS_TYPE.DONE,
    unitType: HOURS_TYPE.DONE,
    hours: hourSettings.doneHours,
    text: 't kurstimer'
  });
  tmpBlocks = tmpBlocks.concat({
    classType: 'timeunit-' + HOURS_TYPE.DONEUNSTRUCTURED,
    unitType: HOURS_TYPE.DONEUNSTRUCTURED,
    hours: hourSettings.doneUnstructuredHours,
    text: 't ikke-strukturerte'
  });
  tmpBlocks = tmpBlocks.concat({
    classType: 'timeunit-' + HOURS_TYPE.PLANNED,
    unitType: HOURS_TYPE.PLANNED,
    hours: hourSettings.plannedHours,
    text: 't påmeldt'
  });
  tmpBlocks = tmpBlocks.concat({
    classType: 'timeunit-' + HOURS_TYPE.SHOPPING,
    unitType: HOURS_TYPE.SHOPPING,
    hours: hourSettings.shoppingHours,
    text: 't i handlekurv'
  });
  return tmpBlocks;
};

CalculatorBar.prototype.setHoursShopping = function(courses) {
  var hours = 0;
  courses.forEach(
    function(course) {
      var year;
      // Check if date is defined. If it is not, we'll just set it to the current year.
      if (course.Date === undefined || course.Date === null) {
        year = new Date().getFullYear();
      } else {
        year = new Date(course.Date).getFullYear();
      }
      // We only want to update this component if the course year is equal to this year.
      if (year >= this.startYear() && year <= this.endYear()) {
        var filteredCredits = filter(course.AuthorizationCredits, {
          AuthorizationType: this.AuthorizationType
        });
        filteredCredits.forEach(
          function(credit) {
            if (credit.CategoryKey === this.CategoryKey) {
              hours += parseFloat(credit.Hours, 10);
            }
          }.bind(this)
        );
      }
    }.bind(this)
  );

  this.localShoppingHours(hours);
};

CalculatorBar.prototype.expand = function() {
  var self = this;
  // If we have the expanded class, we want to close the bar.
  if (this.expandable.hasClass('expanded')) {
    this.$element.removeClass('expanded');
    this.expandable.slideUp(
      250,
      'easeOutQuad',
      function() {
        this.isExpanded(false);
        this.expandable.removeClass('expanded');
        this.siblings.removeClass('faded');
        this.$calculator.removeClass('faded');
      }.bind(this)
    );
    CalculatorTracking.trackCategoryExpanded(this.title, 'closeCategory');
  }
  // If not, we should expand it.
  else {
    this.isExpanded(true);
    var $expanded = this.siblings.find('> .expandable');
    var $calculatorDetail = this.siblings.find('> .calculator-detail');

    this.$parent.removeClass('faded');

    $expanded.removeClass('expanded');
    $expanded.slideUp(250, 'easeOutQuad', function() {
      $calculatorDetail.removeClass('expanded');
    });

    self.parent.toggleBars(self.order);
    self.siblings.addClass('faded');
    self.expandable.addClass('expanded');
    self.$calculator.addClass('faded');

    window.setTimeout(function() {
      self.$element.addClass('expanded');
      self.expandable.slideDown(250, 'easeOutQuad', function() {
        var scrollTarget = self.$element.offset().top - 200;
        self.$htmlBody.animate({ scrollTop: scrollTarget + 'px' });
      });
    }, 10);

    CalculatorTracking.trackCategoryExpanded(this.title, 'expandCategory');
  }
};

CalculatorBar.prototype.init = function(element) {
  this.$htmlBody = $('html, body');
  this.$element = $(element);
  this.$parent = this.$element.parent();
  this.expandable = this.$parent.find('> .expandable');
  this.siblings = this.$parent.siblings();
  this.$calculator = $('.calculator-container:first');
};

module.exports = CalculatorBar;
